import { ConfirmationDialog } from '@/components/patterns/confirmation-dialog'
import { PriceAdjustmentDisableDialog } from './DisableDialog'

export function PriceAdjustmentFormDialogs({ controller }) {
  const {
    disableDialogOpen,
    disableMutation,
    form,
    handleDisable,
    initialData,
    mutation,
    permanentConfirmationOpen,
    persistedAdjustment,
    setDisableDialogOpen,
    setPermanentConfirmationOpen,
  } = controller

  return (
    <>
      <ConfirmationDialog
        open={permanentConfirmationOpen}
        onOpenChange={setPermanentConfirmationOpen}
        variant="destructive"
        title="Make price change permanent?"
        description="This will update the actual product prices for the matching products now. No scheduled price change will be created, and this cannot be automatically undone."
        confirmText="Update prices permanently"
        pendingText="Updating prices..."
        isPending={mutation.isPending}
        onConfirm={() => form.handleSubmit()}
        trigger={<span className="hidden" />}
      />

      {initialData ? (
        <PriceAdjustmentDisableDialog
          adjustment={persistedAdjustment}
          open={disableDialogOpen}
          onOpenChange={setDisableDialogOpen}
          onDisable={handleDisable}
          isPending={disableMutation.isPending}
        />
      ) : null}
    </>
  )
}
